import {useCallback, useEffect, useState} from "react";
import {findHubs} from "../api/RagnarokApi";
import {useSnackbarContext} from "../components/Snackbar";

export default function RagnarokHubList() {
    const [hubs, setHubs] = useState([]);
    const [hubsLoading, setHubsLoading] = useState(false);

    const {handleMessageUpdate} = useSnackbarContext();
    const handleErrorCallback = useCallback(handleError, []);

    useEffect(() => {
        function handleHubsChange(hubs) {
            setHubs(hubs)
        }

        function handleHubsLoadingChange(loading) {
            setHubsLoading(loading);
        }

        handleHubsLoadingChange(true);

        findHubs()
            .then((resp) => resp.json())
            .then((data) => {
                handleHubsChange(data.result);
                handleHubsLoadingChange(false);
            })
            .catch((error) => {
                handleHubsLoadingChange(false);
                handleErrorCallback(error);
            });
    }, [handleErrorCallback]);

    function handleError(error) {
        handleMessageUpdate((error.error && error.error.message) || error.message);
    }

    return {hubs, hubsLoading};
}